import { render, staticRenderFns } from "./PainelItemEdicao.vue?vue&type=template&id=0a8d9ec0&scoped=true"
import script from "./PainelItemEdicao.vue?vue&type=script&lang=js"
export * from "./PainelItemEdicao.vue?vue&type=script&lang=js"
import style0 from "./PainelItemEdicao.vue?vue&type=style&index=0&id=0a8d9ec0&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8d9ec0",
  null
  
)

export default component.exports